module.exports = __webpack_public_path__ + "static/media/logoiterego.e354180d.png";